import NavigationProvider from './src/components/NavigationContext';

export const wrapRootElement = NavigationProvider;